module.exports = __webpack_public_path__ + "static/media/jumping_laddu.1a4b16d1.png";